import {
  Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef, OnDestroy, Output, EventEmitter,
  HostListener
} from "@angular/core";
import {interval} from "rxjs";

import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import {Location} from "@angular/common";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {FormElementService} from "../shared/common/FormElement.service";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators  } from '@angular/forms';
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {TranslateModule} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';
import { PdfFormDesignerComponent, FormElement, FormElementType, Signer, FormConfiguration, FormDesignerOptions } from '../../../../libs/form-designer/projects/pdf-form-designer/src/public-api';
import { allowedWidgetsForMethod, findRecipientsMissingSignatureWidget, getSignMethodMeta, NON_SIGNATURE_WIDGETS } from '../shared/common/signing-method';
import { CommonModule } from '@angular/common';
import {RequestModule} from "../request/request.module";
import {SharedSigningComponent} from "../sharedSigning/shared-signing.component";
import {AttachmentsModalComponent} from "../shared/attachments-modal/attachments-modal.component";

declare var $:any;
declare var Switchery:any;

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-prepare',
    templateUrl: 'prepare.component.html',
    styleUrls: ['prepare.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.FieldsService, Communication.SubscriptionService, Communication.AccesscodeService, Communication.TemplatesService, Communication.AttachmentsService],
  imports: [CommonModule, FormsModule, TranslateModule, PdfFormDesignerComponent, RequestModule, SharedSigningComponent, AttachmentsModalComponent],
    standalone: true
})
export class PrepareComponent implements OnInit, AfterViewInit, OnDestroy {

  isComponentInitialized:boolean=false;
  requestModalVisibility:boolean=false;
  sharedSigningModalVisibility:boolean=false;
  attachmentsModalVisibility:boolean=false;
  attachmentCount:number=0;
  jobIDParameter:number;
  isTemplateMode:boolean=false;
  isValidatingTemplate:boolean=false;
  toogleSidebar:boolean=false;
  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];
  theJob:Communication.Job;
  colors= ["#A9BCF5", "#BCF5A9", "#F3E2A9", "#F5A9A9", "#E6E6E6", "#A9F5F2", "#FE642E", "#F2F2F2", "#DBA901","#AEDEF0", "#FDEFC6", "#ECB7CE", "#FDF4ED", "#F6DDC8","#EDBC92","#FFEDBB","#F2E0E7","#F2E0E7","#5CB5DB","#F6DACA","#F69F99","#9D8FB8"];

  // Legacy properties for backward compatibility during migration
  docFields: any[] = [];
  recipientColors: any = {};
  accordionDisplayId: string = "";
  selectedRecipientIdSubject = new BehaviorSubject("");
  accordionDisplayIdSubject = new BehaviorSubject("");
  selectedShapeSubject = new BehaviorSubject("");
  zoomSubject = new BehaviorSubject("1.0");
  isVariableUniq: boolean = true;
  isLabelUniq: boolean = true;
  shapeOptions: any = {};
  selectedShape: string = "";
  selectedRecipientId: string = "";
  shapeId: number = 1;

  changeOccured:boolean=false;
  toggleValue:boolean = true; //default toogle choice

  page: number = 1;
  rotation: number = 0;
  zoom: number = 1.0;
  originalSize: boolean = true;
  showAll: boolean = true;
  pdf: any;
  renderText: boolean = false;

  pdfSrc: any = {
    'url': '',
    'httpHeaders': {
      'access_token':"1"
    }
  };


  validationStampSettings:{
    enabled:boolean,
    firstPageBottomMargin:number,
    qrCodeXMargin:number,
    qrCodeYMargin:number,
    downloadFromValidation:boolean,
    legalDisclaimer:boolean
  } = {
    enabled:true,
    firstPageBottomMargin:0,
    qrCodeXMargin:0,
    qrCodeYMargin:0,
    downloadFromValidation:false,
    legalDisclaimer:true
  }

  @ViewChild('validationStamp') validationStamp:ElementRef;
  @ViewChild('pdfDesigner') pdfDesigner!: PdfFormDesignerComponent;

  // PDF Form Designer Properties
  externalToolbar: boolean = true;
  signers: Signer[] = [];
  initialConfiguration?: FormConfiguration;
  currentConfiguration?: FormConfiguration;
  isInitialLoading: boolean = true;
  isConfigChangeListenerActive: boolean = false;
  pendingConfigurationLoad?: FormConfiguration;

  // Track signature types per signer (signerId -> signature type)
  private signerSignatureTypes: Map<string, FormElementType> = new Map();

  // Designer Options - all elements except digital signature
  private _designerOptions: FormDesignerOptions = {
    readOnly: false,
    allowedElements: [
      FormElementType.SIGNATURE,
      FormElementType.BIOMETRIC_SIGNATURE,
      FormElementType.INITIALS,
      FormElementType.TEXT,
      FormElementType.TEXT_INPUT,
      FormElementType.CHECKBOX,
      FormElementType.RADIO_BUTTON,
      FormElementType.ATTACHMENTS_LIST
    ] as FormElementType[],
    disabledElements: [] as FormElementType[], // Elements to disable based on signer restrictions
    signers: [],
    layoutMode: 'full-page',
    toolbarPosition: 'external',
    containerClass: 'prepare-designer',
    toolbar: {
      enabled: true,
      external: true,
      showLabels: true,
      showIcons: true
    }
  };

  get designerOptions(): FormDesignerOptions {
    return this._designerOptions;
  }

  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private fieldsApi:Communication.FieldsService,
              private usersApi:Communication.UsersService,
              private subscriptionsApi:Communication.SubscriptionService,
              private accescodeApi:Communication.AccesscodeService,
              private templatesApi:Communication.TemplatesService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private navigationService:NavigationService,
              private toolbarService: ToolbarService,
              private location:Location,
              private authorization: Authorization,
              private notificationService: NotificationService,
              private translate: TranslateService,
              private formElementService: FormElementService,
              private attachmentsApi: Communication.AttachmentsService
  )
  {


  }

  /**
   * Validates if the job is actually a template using API endpoint
   * GOLDEN RULE: Prevents real jobs from being edited in template mode
   */
  private async validateTemplateJob(jobId: number): Promise<boolean> {
    try {
      this.isValidatingTemplate = true;
      const accessToken = this.authorization.getAccessToken();

      // Use GET /templates/{jobId} endpoint
      const template = await this.templatesApi.templateGet(accessToken, jobId).toPromise();

      console.log('[Template Validation] Job is a valid template:', template);
      return true;
    } catch (error) {
      // 400 error means it's NOT a template
      console.log('[Template Validation] Job is NOT a template:', error);
      return false;
    } finally {
      this.isValidatingTemplate = false;
    }
  }


  async ngOnInit() {
    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);

    } else {
      // Set locale for form designer based on current language from localStorage
      let locale: 'en' | 'tr' | 'nl' = 'en';
      try {
        const account = localStorage.getItem('account');
        if (account) {
          const accountData = JSON.parse(account);
          const accountLanguage = accountData.language;
          if (accountLanguage && ['en', 'tr', 'nl'].includes(accountLanguage)) {
            locale = accountLanguage as 'en' | 'tr' | 'nl';
          }
        }
      } catch (e) {
        console.warn('Could not read language from localStorage, using default:', e);
      }
      this._designerOptions = {
        ...this._designerOptions,
        locale: locale
      };

      //for mobile, if class exist remove it
      if ($('body').is('.sidebar-mobile-main')) {
        $('body').removeClass('sidebar-mobile-main');
      }

      // Detect template mode from route
      const currentUrl = this.router.url;
      this.isTemplateMode = currentUrl.includes('/template/');
      console.log('[Template Mode] Enabled:', this.isTemplateMode);

      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
        (event: NavigationEvent) => this.onNavigationEvent(event)
      ));

      this.subscriptions.push(this.activatedRoute.params.subscribe(
        async (param) => {
          //convert string to number with +
          this.jobIDParameter = +param['id'];
          console.log("jobId:" + this.jobIDParameter);

          // VALIDATION: Check if job type matches route mode
          if (this.isTemplateMode) {
            const isValidTemplate = await this.validateTemplateJob(this.jobIDParameter);

            if (!isValidTemplate) {
              // GOLDEN RULE ENFORCEMENT: Real job accessed via template route
              this.notificationService.displayError({message: this.translate.instant("This is not a template. Redirecting to prepare mode.")});
              this.router.navigate(['/prepare', this.jobIDParameter]);
              return;
            }
          } else {
            // Optional: Validate real jobs are not templates
            const isTemplate = await this.validateTemplateJob(this.jobIDParameter);

            if (isTemplate) {
              // GOLDEN RULE ENFORCEMENT: Template accessed via real job route
              this.notificationService.displayError({message: this.translate.instant("This is a template. Redirecting to template mode.")});
              this.router.navigate(['/template', this.jobIDParameter]);
              return;
            }
          }

        })
      );

      this.GetTheJob();
    }
  }


  public GetTheJob(){
    this.subscriptions.push(this.jobsApi.jobsIdGet(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      (response:Communication.Job) => {

        if(this.theJob && this.theJob.recipients != response.recipients){
          console.log(this.theJob.recipients, response.recipients)

          let newIds:any = response.recipients.map(x => x.id);
          let previosIds:any = this.theJob.recipients.map(x => x.id);
          let differenceIds = previosIds.filter((x:any) => newIds.indexOf(x) == -1);

          if(differenceIds.length > 0){
            let filteredFields:any = this.docFields.filter((x:any) => differenceIds.indexOf(x.recipientId) == -1 );
            console.warn("filteredFields ",filteredFields);

            //set new fields
            this.docFields = filteredFields;

            //remove recipient assigned color
            for (let k = 0; k < differenceIds.length; k++)
              delete this.recipientColors[differenceIds[k]];

            //unset selected accordion
            this.accordionDisplayId = "";

            //refresh shapes
            this.selectedRecipientIdSubject.next("");
          }

        }

        this.theJob = response;
        this.validationStampSettings.firstPageBottomMargin = +response.validationAreaBottomMargin;
        this.validationStampSettings.legalDisclaimer = response.validationStampLegalText == "true";
        this.validationStampSettings.qrCodeXMargin = +response.qrCodeXMargin;
        this.validationStampSettings.qrCodeYMargin = +response.qrCodeYMargin;
        this.validationStampSettings.downloadFromValidation = response.downloadFromValidation == "true";

        if( response.validationStamp == "false"){
          this.validationStampSettings.enabled = false;
          this.toggleValue = false;
        }

        // Setup signers from recipients for pdf-form-designer
        this.setupSignersFromRecipients();

        for(let i=0;i<this.theJob.recipients.length;i++){
          let value = this.recipientColors[this.theJob.recipients[i].id];
          if(!value){
            this.recipientColors[this.theJob.recipients[i].id] = this.colors[Object.keys(this.recipientColors).length % this.colors.length];
          }
        }

        //To select first element at start
        let recipientId:string = String(this.theJob.recipients[0].id);
        this.accordionSettings(recipientId);
        this.selectedRecipientIdSubject.next(recipientId);

        console.log("job:", response);
        console.log("recipientColors ", this.recipientColors);

        if(!this.isComponentInitialized)
        {
          this.isComponentInitialized = true;

          this.loadExistingFields();

          // Use appropriate toolbar page based on mode
          const toolbarPage = this.isTemplateMode
            ? ToolbarEventPageEnum.TEMPLATE_PREPARE
            : ToolbarEventPageEnum.PREPARE;

          this.toolbarService.action(new ToolbarEvent(toolbarPage, response.type, response.user.id, "", response.name, response.status, "", "", ""));

          let documentModel: Communication.Document = response.documents[0];
          let fileURL: string = Config.WEBSERVICEURL + '/documents/' + documentModel.id + '/download';
          let accessToken: string = this.authorization.getAccessToken();

          this.loadFile(fileURL, accessToken);

          console.log("job: " + this.theJob.status + " - " + this.theJob.type);
          console.log("documentID " + this.theJob.documents[0].id);

          // Load attachment count for badge and finish validation
          this.loadAttachmentCount();
        }
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  loadFile(fileURL:string, accessToken:string) {
    let xhr:any = new XMLHttpRequest();
    xhr.open('HEAD', fileURL, false);
    xhr.setRequestHeader('access_token', accessToken);
    xhr.send();

    if (xhr.status == "200"){
      this.pdfSrc.url = fileURL;
      this.pdfSrc.httpHeaders.access_token = accessToken;
    } else {
      this.notificationService.documentNotFound();
    }
  }



  public saveJob(){
    this.subscriptions.push(
      this.jobsApi.jobsIdActionsSavePut(
        this.authorization.getAccessToken(),
        this.jobIDParameter,
        this.theJob.subject,
        this.theJob.message,
        String(this.toggleValue),
        this.validationStampSettings.firstPageBottomMargin.toString(),
        this.validationStampSettings.legalDisclaimer.toString(),
        this.validationStampSettings.qrCodeXMargin.toString(),
        this.validationStampSettings.qrCodeYMargin.toString(),
        String(this.validationStampSettings.downloadFromValidation),
      ).subscribe(
        response => {
          console.log("job saved...");
          this.notificationService.validationStampOptionUpdated();
        }, //Bind to view
        err => {
          // Log errors if any
          console.log(err);
          this.notificationService.displayError(err);
        }
      )
    );
  }

  ngAfterViewInit(): void {
    // PDF form designer will be initialized after view loads
    console.log('PrepareComponent after view init');
    this.initializeSwitchery();
  }

  getDocFields(){
    this.subscriptions.push(this.fieldsApi.documentsIdFieldsGet(this.authorization.getAccessToken(),  this.theJob.documents[0].id).subscribe(
      (response) => {
        console.log("GET/docFields... " + this.docFields.length + " Şekil mevcut");
        console.log(response);

        let allFields:Array<Communication.DocumentField> = response;

        for(let i=0; i<allFields.length; i++)
        {
          let fields:any={};
          fields.id = this.shapeId++;
          fields.documentId = allFields[i].documentId;
          fields.recipientId = allFields[i].recipientId;
          fields.page = allFields[i].page;
          fields.type = allFields[i].type;
          fields.width = allFields[i].width;
          fields.height = allFields[i].height;
          fields.x = allFields[i].x;
          fields.y = allFields[i].y;
          fields.label = allFields[i].label;
          fields.enabled = allFields[i].enabled;
          fields.initialValue = allFields[i].initialValue;
          fields.value = allFields[i].value;
          fields.variable = allFields[i].variable;
          fields.validation = allFields[i].validation;
          fields.orderno = allFields[i].orderno;
          fields.required = allFields[i].required;
          fields.options = allFields[i].options;

          this.docFields.push(fields);
        }

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  isMobile(){
    return /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && screen.width <= 768
  }

  private onNavigationEvent(event:NavigationEvent) {
    switch (event.acton) {
      case "INCREMENT_ZOOM":
        this.incrementZoom(Number(event.value));
        break;
      case "EDIT_RECIPIENTS": {
        this.requestModalVisibility = true;
      }
        break;
      case "CLOSE_REQUEST":
        this.CloseRequest();
        break;
      case "FINISH_SEND_REQUEST":
        if (this.isTemplateMode) {
          // GOLDEN RULE: Block send/finish for templates
          this.notificationService.displayError({message: this.translate.instant("Templates cannot be sent. This is template editing mode.")});
          console.error('[Template Mode] Attempted to send template - BLOCKED');
          return;
        }
        this.FinishSendRequest();
        break;
      case "SHARED_SIGNING":
        this.sharedSigningModalVisibility = true;
        break;
      case "OPEN_ATTACHMENTS":
        this.openAttachmentsModal();
        break;
    }
  }

  incrementZoom(amount:number) {
    // Use pdf-form-designer zoom methods instead of manual calculation
    if (this.pdfDesigner) {
      if (amount > 0) {
        this.pdfDesigner.zoomIn();
      } else if (amount < 0) {
        this.pdfDesigner.zoomOut();
      }
    } else {
      console.warn('PDF designer not available for zoom control');
    }
  }


  public async CloseRequest(){
    try {
      // Save configuration to backend
      await this.saveConfiguration();

      // Navigate based on mode
      if (this.isTemplateMode) {
        // Navigate back to templates list
        this.router.navigate(["/docs"], {});
      } else {
        // Navigate to job details page after successful save
        this.router.navigate(["/doc", this.jobIDParameter]);
      }
    } catch (error) {
      console.error("Error saving configuration:", error);
      // Navigate anyway even if save fails
      if (this.isTemplateMode) {
        this.router.navigate(["/docs"], { });
      } else {
        this.router.navigate(["/doc", this.jobIDParameter]);
      }
    }
  }

  openAttachmentsModal(): void {
    this.attachmentsModalVisibility = true;
    setTimeout(() => { $('#attachmentsModal').modal('show'); }, 100);
  }

  onAttachmentsClosed(): void {
    this.attachmentsModalVisibility = false;
  }

  onAttachmentsChanged(count: number): void {
    this.attachmentCount = count;
    this.emitToolbarWithAttachmentCount();
  }

  loadAttachmentCount(): void {
    if (!this.theJob?.documents?.[0]?.id) return;
    this.attachmentsApi.documentsIdAttachmentsGet(
      this.authorization.getAccessToken(),
      this.theJob.documents[0].id
    ).subscribe(
      (response: Communication.AttachmentListResponse) => {
        this.attachmentCount = response.count || 0;
        this.emitToolbarWithAttachmentCount();
      },
      (err) => { console.error('Error loading attachment count:', err); }
    );
  }

  private emitToolbarWithAttachmentCount(): void {
    const toolbarPage = this.isTemplateMode
      ? ToolbarEventPageEnum.TEMPLATE_PREPARE
      : ToolbarEventPageEnum.PREPARE;
    let event = new ToolbarEvent(toolbarPage, this.theJob.type, this.theJob.user.id, "", this.theJob.name, this.theJob.status, "", "", "");
    event.attachmentCount = this.attachmentCount;
    this.toolbarService.action(event);
  }

  public FinishSendRequest(){
      let _self = this;

        if (_self.theJob.recipients.length == 0) { // imza için recipient olmalı
          _self.notificationService.noRecipientExist();
          return;
        }

        // Check: if attachments exist but no file-list widget is placed, block send
        if (_self.attachmentCount > 0) {
          const hasFileListElement = _self.currentConfiguration?.elements?.some(
            (element: any) => element.type === 'file-list'
          ) || false;

          if (!hasFileListElement) {
            _self.notificationService.displayError({
              message: _self.translate.instant('ATTACHMENTS_REQUIRE_LIST_WIDGET')
            });
            return;
          }
        }

        // Block send when a bio/initials recipient has no matching signature widget.
        // QES and legacy-null recipients are exempt.
        const missingSignatureRecipients = findRecipientsMissingSignatureWidget(_self.theJob?.recipients, _self.currentConfiguration?.elements);
        if (missingSignatureRecipients.length) {
          _self.notificationService.signatureAreaMissing(
            missingSignatureRecipients.map((r: any) => r.name || r.email || (r.id != null ? r.id.toString() : ''))
          );
          return;
        }

        {

          if (!_self.changeOccured) {

            let subject: string = "";
            let message: string = "";

            //if null, then set it or use existing
            if (!_self.theJob.subject)
              subject = _self.translate.currentLang == "tr" ? "'" + _self.theJob.name + "' " + _self.translate.instant("Approval required for") : _self.translate.instant("Approval required for") + " '" + _self.theJob.name + "'";
            else
              subject = _self.theJob.subject;

            if (!_self.theJob.message)
              message = _self.translate.instant("Hello") + ",\n\n" + _self.translate.instant("The related document has been sent for signature.") + "\n\n" + _self.authorization.userProfile.user_metadata.name + "\n\n";
            else
              message = _self.theJob.message;

            _self.subscriptions.push(_self.jobsApi.jobsIdActionsFinishPut(_self.authorization.getAccessToken(), _self.jobIDParameter, subject, message, String(_self.toggleValue)).subscribe(
              response => {
                _self.notificationService.signingRequestSent();
                console.log("Finish - status " + response.status);
                setTimeout(function(){ _self.router.navigate(["/doc", _self.jobIDParameter])}, 100);
                //_self.RequestCode();
              }, //Bind to view
              err => {
                // Log errors if any
                console.log(err);
                _self.notificationService.displayError(err);
              }
            ));
          }
      }

  }

    getCanvasPageNumber(canvasElement:any):any{
      return canvasElement.parentElement.parentElement.getAttribute("data-page-number");
    }

    getCanvasInPage(pageNumber: any): any {
      // get element that has attribute 'data-page-number' = given pageNumber
      let pageElement = document.querySelector(`[data-page-number="${pageNumber}"]`);
      return pageElement.getElementsByTagName("canvas")[0];
    }

    //color code to rgba for transparent convertion
    hexToRGBA(hex:any, opacity:any) {
      return 'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length/3 + '})', 'g')).map(function(l:any) { return parseInt(hex.length%2 ? l+l : l, 16) }).concat(opacity).join(',') + ')'; //opacity||1
    }

  saveSettings() {
    console.log("new options -> ",this.shapeOptions);

    let shape: any = this.docFields.find((x: any) => x.id == this.shapeOptions.shapeId);
    let index = this.docFields.indexOf(shape);
    let options: any = {};

    switch (shape.type) {
      case "text-area": {
        let sliderTransparencyValue:string = $("#slider-transparency").slider('getValue');
        let sliderRotateValue:string = $("#slider-rotate").slider('getValue');

        options = { font : this.shapeOptions.font, size : this.shapeOptions.size, color : this.shapeOptions.color, transparency : sliderTransparencyValue, rotateAngle: sliderRotateValue };

        this.docFields[index].options = JSON.stringify(options);
        this.docFields[index].variable = this.shapeOptions.variable;
        this.docFields[index].enabled = String(this.shapeOptions.enabled);
      }
        break;
      case "text-input": {
        options = { font : this.shapeOptions.font, size : this.shapeOptions.size };
        this.docFields[index].options = JSON.stringify(options);
        this.docFields[index].required = String(this.shapeOptions.required);
        this.docFields[index].initialValue = this.shapeOptions.initialValue;
        this.docFields[index].variable = this.shapeOptions.variable;
        this.docFields[index].enabled = String(this.shapeOptions.enabled);
      }
        break;
      case "sign-area": {
        options = { font : this.shapeOptions.font, size : this.shapeOptions.size };
        this.docFields[index].options = JSON.stringify(options);
        this.docFields[index].required = String(this.shapeOptions.required);
        this.docFields[index].initialValue = this.shapeOptions.initialValue;
      }
        break;
      case "checkbox": {
        this.docFields[index].required = String(this.shapeOptions.required);
        this.docFields[index].variable = this.shapeOptions.variable;
        this.docFields[index].enabled = String(this.shapeOptions.enabled);
      }
        break;
      case "radio": {
        this.docFields[index].variable = this.shapeOptions.variable;
        this.docFields[index].label = this.shapeOptions.label;
        this.docFields[index].enabled = String(this.shapeOptions.enabled);

      }
        break;
      case "initials":{
        let pageVar = shape.page;
        if(!String(pageVar).startsWith("page")) {
          pageVar = "page" + pageVar;
        }
        pageVar = document.getElementById(pageVar);

        options = { x : this.shapeOptions.x, y : this.shapeOptions.y };
        this.docFields[index].options = JSON.stringify(options);

        this.docFields[index].x = this.shapeOptions.x;
        this.docFields[index].y = this.shapeOptions.y;
      }
        break;
      default:
        console.warn("shape type unknown...");
    }

    this.selectedRecipientIdSubject.next(this.selectedRecipientId);
    this.changeOccured = true;
  }

  toggleDownload(){
    this.validationStampSettings.downloadFromValidation = !(this.validationStampSettings.downloadFromValidation);
  }


  initializeSwitchery(){
    //Initialize switchery
    let planName:string = this.authorization.userAccount.subscription.plan.name;
    let isDisabled:boolean = planName != "ENTERPRISE";
    let opacity = planName == "ENTERPRISE" ? 1 : 0.75;

    let elems:any = document.querySelectorAll('.js-switch');

    for (let i = 0; i < elems.length; i++) {
      let switchery:any = new Switchery(elems[i] , { disabled: isDisabled, disabledOpacity: opacity, size: 'small' });
    }

    //Control changes
    let self = this;
    let changeCheckbox:any = document.querySelector('.js-check-change');

    this.subscriptions.push(this.jobsApi.jobsIdGet(this.authorization.getAccessToken(), this.jobIDParameter).subscribe(
      (response:Communication.Job) => {


        if (response.validationStamp == "false") {
          this.validationStampSettings.enabled = false;
          this.toggleValue = false;
          $("#validation-stamp").click();
        }


        changeCheckbox.onchange = function() {
          if(self.toggleValue){
            $("#validation-stamp").click();
            $("#validationStampSettings").modal();
          } else {
            console.log("toggleValue ", true);
            self.toggleValue = true;
            self.validationStampSettings.enabled = true;
            $("#vsEnabled").click();
            self.saveJob();
            console.log(self.validationStampSettings)
          }
        };


      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));



    let badge:any = document.querySelector('.badge-secondary');
    badge.addEventListener("click", function clicked() {
      if(isDisabled){
        self.notificationService.showCurrentPlanNotSuitToDo(function(isConfirmed:boolean) {
          if (isConfirmed){}
        })
      }
    });

  }

  saveValidationStampSettings(){
    console.log(this.validationStampSettings)
    if(!this.validationStampSettings.enabled){
      $("#validation-stamp").click();
      $("#validation-stamp").prop("checked",false);
      this.toggleValue = false;
    } else {
      // $("#validation-stamp").click();
      $("#validation-stamp").prop("checked",true);
    }
    this.saveJob();
  }


  // =====================================
  // Signer Management Methods
  // =====================================
  private setupSignersFromRecipients(): void {
    if (!this.theJob?.recipients) return;

    this.signers = this.theJob.recipients.map((recipient, index) => {
      const meta = getSignMethodMeta(recipient.signMethod);
      return {
        id: recipient.id.toString(),
        name: recipient.name,
        email: recipient.email,
        color: this.colors[index % this.colors.length],
        signMethodLabel: meta ? this.translate.instant(meta.labelKey) : undefined,
        signMethodColor: meta ? meta.accent : undefined,
        signMethodBgColor: meta ? meta.accentTint : undefined
      };
    });

    // Set first signer as active
    if (this.signers.length > 0) {
      this.updateDesignerOptions();
    }
  }

  private updateDesignerOptions(activeSignerId?: string): void {
    // Use provided activeSignerId or default to first signer
    const signerId = activeSignerId || this.signers[0]?.id;

    this._designerOptions = {
      ...this._designerOptions,
      signers: this.signers,
      activeSignerId: signerId,
      allowedElements: this.allowedElementsForSigner(signerId),
      toolbar: {
        external: this.externalToolbar
      }
    };

    // Update disabled elements for the active signer
    if (signerId) {
      this.updateDisabledElementsForSigner(signerId);
    }
  }

  // Restrict the signature-family widget to the active recipient's
  // explicit signing method. Legacy-null recipients keep the full toolbar.
  private readonly defaultAllowedElements: FormElementType[] = [
    FormElementType.SIGNATURE,
    FormElementType.BIOMETRIC_SIGNATURE,
    FormElementType.INITIALS,
    ...(NON_SIGNATURE_WIDGETS as FormElementType[])
  ];

  private allowedElementsForSigner(signerId?: string): FormElementType[] {
    const recipient = this.theJob?.recipients?.find(r => r.id?.toString() === signerId);
    const allowed = allowedWidgetsForMethod(recipient?.signMethod);
    return allowed ? (allowed as FormElementType[]) : this.defaultAllowedElements;
  }

  // =====================================
  // Sign Type Restrictions Logic
  // =====================================
  private updateSignTypeRestrictions(configuration: FormConfiguration): void {
    // Clear and rebuild the signer signature types map
    this.signerSignatureTypes.clear();

    // Check which sign types each signer has
    configuration.elements.forEach(element => {
      if (element.type === FormElementType.SIGNATURE ||
          element.type === FormElementType.BIOMETRIC_SIGNATURE ||
          element.type === FormElementType.INITIALS) {
        // Track the signature type for this signer
        this.signerSignatureTypes.set(element.signerId, element.type);
      }
    });

    // Update disabled elements for the currently active signer
    const activeSignerId = this._designerOptions.activeSignerId;
    if (activeSignerId) {
      this.updateDisabledElementsForSigner(activeSignerId);
    }
  }

  private updateDisabledElementsForSigner(signerId: string): void {
    // Get the signature type this signer has already placed (if any)
    const existingSignatureType = this.signerSignatureTypes.get(signerId);

    if (existingSignatureType) {
      // Signer has already placed a signature type - disable the other signature types
      const signatureTypes = [
        FormElementType.SIGNATURE,
        FormElementType.BIOMETRIC_SIGNATURE,
        FormElementType.INITIALS
      ];

      // Disable all signature types except the one already placed
      const disabledSignatureTypes = signatureTypes.filter(type => type !== existingSignatureType);

      this._designerOptions = {
        ...this._designerOptions,
        disabledElements: disabledSignatureTypes
      };
    } else {
      // No signature type placed yet - enable all signature types
      this._designerOptions = {
        ...this._designerOptions,
        disabledElements: []
      };
    }
  }

  // =====================================
  // Configuration Change Handler
  // =====================================
  onConfigurationChange(configuration: FormConfiguration): void {
    this.currentConfiguration = configuration;
    console.log('Configuration changed:', configuration);

    this.updateDesignerOptions(configuration.activeSignerId);

    // Update sign type restrictions
    this.updateSignTypeRestrictions(configuration);

    // Only save if we're not in initial loading state and listener is active
    if (!this.isInitialLoading && this.isConfigChangeListenerActive) {
      this.changeOccured = true;
      console.log('Auto-saving configuration changes...');
      this.saveConfiguration().catch(error => {
        console.error('Auto-save failed:', error);
      });
    } else {
      console.log('Skipping auto-save during initial loading');
    }
  }

  onPdfLoaded(event: any): void {
    console.log('PDF loaded:', event);

    // Check if we have a pending configuration to load
    if (this.pendingConfigurationLoad && this.pdfDesigner) {
      console.log('Loading pending configuration into designer');
      setTimeout(() => {
        this.pdfDesigner.loadConfiguration(this.pendingConfigurationLoad!);
        this.pendingConfigurationLoad = undefined;
      }, 100); // Small delay to ensure PDF is fully rendered
    }
  }

  onZoomChange(zoom: number): void {
    this.zoom = zoom;
  }


  // =====================================
  // Save Configuration Method
  // =====================================
  saveConfiguration(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ( !this.theJob?.documents?.[0]) {
        console.log('Cannot save: missing job document');
        resolve();
        return;
      }

      let json: string = '[]';

      if( this.currentConfiguration ) {
        // Convert FormElements to DocumentFields
        const signerMap = new Map(this.signers.map(s => [s.id, Number(s.id)]));
        const documentFields = this.formElementService.convertFormElementsToFields(
          this.currentConfiguration.elements,
          this.theJob.documents[0].id,
          signerMap
        );

        // Save to API
        json = JSON.stringify(documentFields);
      }

      this.subscriptions.push(
        this.fieldsApi.documentsIdFieldsPut(
          this.authorization.getAccessToken(),
          this.theJob.documents[0].id,
          json
        ).subscribe(
          (response: any) => {
            console.log("Form configuration saved to REST API");
            this.changeOccured = false;
            resolve();
          },
          (error: any) => {
            console.error("Error saving configuration:", error);
            reject(error);
          }
        )
      );
    });
  }

  // =====================================
  // Legacy Methods for Template Compatibility
  // =====================================
  checkIsVariableIniq(): void {
    // Legacy method for template compatibility - not used in new system
    this.isVariableUniq = true;
  }

  accordionSettings(recipientId: any): void {
    // Update accordion display ID
    this.accordionDisplayId = recipientId.toString();

    // Also update the active signer in the form designer
    this.selectRecipient(recipientId.toString());
  }

  /**
   * Handle recipient selection - updates active signer and disabled elements
   */
  selectRecipient(recipientId: string): void {
    // Update the selected recipient ID
    this.selectedRecipientId = recipientId;

    // Update the designer options with the new active signer
    this.updateDesignerOptions(recipientId);

    // Trigger change detection
    this.selectedRecipientIdSubject.next(recipientId);
  }

  selectShapeDiv(elementId: string): void {
    // Legacy method for template compatibility - not used in new system
    this.selectedShape = elementId;
  }

  showSidebar(): void {
    // Toggle sidebar visibility
    this.toogleSidebar = !this.toogleSidebar;
  }

  showRequest(): void {
    // Open request modal
    this.requestModalVisibility = true;
  }

  showSharedSigning(): void {
    // Open shared signing modal
    this.sharedSigningModalVisibility = true;
  }

  requestModalClosed(): void {
    this.requestModalVisibility = false;
  }

  sharedSigningClosed(): void {
    this.sharedSigningModalVisibility = false;
  }

  onRecipientAdded(recipient: Communication.Recipient): void {
    console.log('Recipient added:', recipient);

    // Add signer to pdfDesigner directly
    if (this.pdfDesigner) {
      const signer = this.pdfDesigner.addSigner(
        recipient.name,
        recipient.email,
        recipient.id.toString()
      );

      if (signer) {
        // addSigner returns a bare signer (name/email/color only) — populate the
        // signing-method metadata so the signer-list badge renders on first load,
        // matching what setupSignersFromRecipients does on a page refresh.
        const meta = getSignMethodMeta(recipient.signMethod);
        signer.signMethodLabel = meta ? this.translate.instant(meta.labelKey) : undefined;
        signer.signMethodColor = meta ? meta.accent : undefined;
        signer.signMethodBgColor = meta ? meta.accentTint : undefined;

        // Update local signers array to match
        this.signers.push(signer);

        // Assign color to recipientColors for consistency
        if (!this.recipientColors[recipient.id]) {
          this.recipientColors[recipient.id] = signer.color;
        }

        // If this is the first signer, activate it
        if (this.signers.length === 1) {
          this.pdfDesigner.activateSigner(signer.id);
          this.updateDesignerOptions(signer.id);
        }
      }
    }
  }

  onRecipientRemoved(recipient: Communication.Recipient): void {
    console.log('Recipient removed:', recipient);

    // Remove signer from pdfDesigner directly
    if (this.pdfDesigner) {
      const signerId = recipient.id.toString();
      const removed = this.pdfDesigner.removeSigner(signerId);

      if (removed) {
        // Update local signers array
        const index = this.signers.findIndex(s => s.id === signerId);
        if (index !== -1) {
          this.signers.splice(index, 1);
        }

        // Remove from recipientColors
        delete this.recipientColors[recipient.id];

        // If we removed the active signer, update designer options
        if (this.selectedRecipientId === signerId) {
          const newActiveId = this.pdfDesigner.getActiveSigner()?.id;
          if (newActiveId) {
            this.updateDesignerOptions(newActiveId);
            this.selectedRecipientId = newActiveId;
          }
        }
      }
    }
  }

  onRecipientUpdated(recipient: Communication.Recipient): void {
    console.log('Recipient updated:', recipient);

    // Update signer in pdfDesigner directly
    if (this.pdfDesigner) {
      const signerId = recipient.id.toString();
      const signer = this.pdfDesigner.getSignerById(signerId);

      if (signer) {
        // Keep theJob in sync so the widget allow-list reads the new method.
        const jobRecipient = this.theJob?.recipients?.find(r => r.id?.toString() === signerId);
        if (jobRecipient) {
          jobRecipient.signMethod = recipient.signMethod;
        }

        // Recompute the signing-method badge metadata for the edited recipient.
        const meta = getSignMethodMeta(recipient.signMethod);
        const signMethodLabel = meta ? this.translate.instant(meta.labelKey) : undefined;
        const signMethodColor = meta ? meta.accent : undefined;
        const signMethodBgColor = meta ? meta.accentTint : undefined;

        // Update the designer's signer in place (drives the signer-list badge).
        signer.name = recipient.name;
        signer.email = recipient.email;
        signer.signMethodLabel = signMethodLabel;
        signer.signMethodColor = signMethodColor;
        signer.signMethodBgColor = signMethodBgColor;

        // Mirror into our local signers array (may be a separate reference).
        const index = this.signers.findIndex(s => s.id === signerId);
        if (index !== -1 && this.signers[index] !== signer) {
          this.signers[index].name = recipient.name;
          this.signers[index].email = recipient.email;
          this.signers[index].signMethodLabel = signMethodLabel;
          this.signers[index].signMethodColor = signMethodColor;
          this.signers[index].signMethodBgColor = signMethodBgColor;
        }

        // If the edited signer is the one active in the designer, refresh the
        // Properties toolbar so the available widgets match the new method
        // immediately. Use the designer's own active signer — selectedRecipientId
        // can be stale because designer-driven activation doesn't update it.
        const activeSignerId = this.pdfDesigner.getActiveSigner()?.id;
        if (activeSignerId === signerId) {
          this.updateDesignerOptions(signerId);
        }

        console.log(`Updated signer ${signerId}: ${recipient.name} (${recipient.email}), method ${recipient.signMethod}`);
      }
    }
  }

  onJobUpdated(job: Communication.Job): void {
    console.log('Job updated:', job);
    this.theJob = job;
    // Don't call setupSignersFromRecipients here - we're managing signers directly
  }


  // =====================================
  // Load Existing Fields Method
  // =====================================
  private loadExistingFields(): void {
    if (!this.theJob?.documents?.[0]) return;

    console.log('Loading existing fields for document:', this.theJob.documents[0].id);

    this.subscriptions.push(
      this.fieldsApi.documentsIdFieldsGet(
        this.authorization.getAccessToken(),
        this.theJob.documents[0].id
      ).subscribe(
        (response: Communication.DocumentField[]) => {
          console.log('Existing fields loaded:', response);

          // Convert fields to FormConfiguration and update initial configuration
          if (response && response.length > 0) {
            const recipientMap = new Map(this.signers.map(s => [Number(s.id), s.id]));
            const elements = this.formElementService.convertFieldsToFormElements(response, recipientMap);

            // Populate signerSignatureTypes map from existing fields
            elements.forEach(element => {
              if (element.type === FormElementType.SIGNATURE ||
                  element.type === FormElementType.BIOMETRIC_SIGNATURE ||
                  element.type === FormElementType.INITIALS) {
                this.signerSignatureTypes.set(element.signerId, element.type);
              }
            });

            this.initialConfiguration = {
              version: '3.0.0' as const,
              elements: elements,
              pageCount: 1,
              signers: this.signers,
              activeSignerId: this.signers[0]?.id || '',
              metadata: {
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                author: 'prepare',
                coordinateSystem: 'PDF_EXACT_POINTS' as const
              }
            };

            console.log('Loading configuration with', elements.length, 'elements');
            console.log('Signer signature types:', Array.from(this.signerSignatureTypes.entries()));

            // Update disabled elements for the active signer
            if (this.signers[0]?.id) {
              this.updateDisabledElementsForSigner(this.signers[0].id);
            }

            // Call the pdf-form-designer component to load the configuration
            if (this.pdfDesigner ) {
              console.log('Loading configuration immediately into designer');
              this.pdfDesigner.loadConfiguration(this.initialConfiguration);
            } else {
              console.log('PDF designer not ready, storing configuration for later load');
              this.pendingConfigurationLoad = this.initialConfiguration;
            }
          } else {
            // Create empty initial configuration
            this.initialConfiguration = {
              version: '3.0.0' as const,
              elements: [],
              pageCount: 1,
              signers: this.signers,
              activeSignerId: this.signers[0]?.id || '',
              metadata: {
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
                author: 'prepare',
                coordinateSystem: 'PDF_EXACT_POINTS' as const
              }
            };
          }

          // Finish initial loading and activate configuration change listener
          this.completeInitialLoading();
        },
        (error: any) => {
          console.error('Error loading existing fields:', error);
          // Still complete loading even if no fields found
          this.completeInitialLoading();
        }
      )
    );
  }

  private completeInitialLoading(): void {
    console.log('Initial loading complete - activating configuration change listener');
    this.isInitialLoading = false;

    // Add a small delay to ensure the designer component has fully initialized
    setTimeout(() => {
      this.isConfigChangeListenerActive = true;
      console.log('Configuration change listener activated');
    }, 100);
  }

  // ========================================
  // BETA FEATURE
  // ========================================
  /**
   * BETA: Download PDF preview with form design applied using the /documents/{id}/applyDesign endpoint
   */
  downloadDesignPreview(): void {
    if (!this.theJob?.documents?.[0]?.id) {
      this.notificationService.displayError('No document available for download');
      return;
    }

    const documentId = this.theJob.documents[0].id;
    const accessToken = this.authorization.getAccessToken();

    console.log('[BETA] Downloading design preview for document:', documentId);

    this.subscriptions.push(
      this.documentsApi.documentsIdApplyDesignGet(accessToken, documentId).subscribe(
        (blob: Blob) => {
          // Create download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `preview-${this.theJob.name || documentId}.pdf`;

          // Trigger download
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          console.log('[BETA] Design preview downloaded successfully');
        },
        (error: any) => {
          console.error('[BETA] Error downloading design preview:', error);
          this.notificationService.displayError('Failed to download design preview');
        }
      )
    );
  }
  // ========================================
  // END BETA FEATURE
  // ========================================

  ngOnDestroy() {
    // Clean up subscriptions
    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }

  toggleLegalDisclaimer() {
    this.validationStampSettings.legalDisclaimer = !(this.validationStampSettings.legalDisclaimer);
  }
}


class Container {
  constructor(public page:string, public canvas:any, public bgPanel:any) {}
}
